import { BouncebanChip, Icon, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import { VARIANT_COPY } from '../../config';
import * as SX from './sx';
import type { CurrentPlanInclusionProps as Props } from './types';

export const CurrentPlanInclusion = memo(({ plan, className }: Props) => {
  const copy = VARIANT_COPY[plan.variant];

  return (
    <Box className={classnames('CurrentPlanInclusion', className)} sx={SX.root}>
      <Box sx={SX.header}>
        <Typography variant="body2" fontWeight={700} color="grey.900">
          {copy.inclusionTitle}
        </Typography>
        <Typography variant="body5" color="grey.600">
          {copy.inclusionKicker} · Renewal {plan.renewal}
        </Typography>
      </Box>
      <Divider sx={SX.headerDivider} />
      <Box sx={SX.content}>
        <Box sx={SX.grid}>
          {plan.featureGroups.map((group) => (
            <Box key={group.title} sx={SX.group}>
              <Typography variant="body3" fontWeight={700} color="primary.600">
                {group.title}
              </Typography>
              {group.features.map((feature) => (
                <Box key={feature.id} sx={SX.featureRow}>
                  <Box sx={SX.checkmark}>
                    <Icon name="check" size={16} color="primary.main" />
                  </Box>
                  <Typography variant="body3" color="grey.500" fontWeight={400}>
                    {feature.title}
                  </Typography>
                  {feature.poweredBy && <BouncebanChip />}
                  {feature.comingSoon && (
                    <Label color="default" variant="soft" size="xxsmall">
                      Coming Soon
                    </Label>
                  )}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
});

CurrentPlanInclusion.displayName = 'CurrentPlanInclusion';
